import { qsa } from './utils.js';

export function initDropdowns (container, {
    patientDropdownId = '#patient-dropdown',
    errorClass = 'error',
    onChange = () => { },
    onReminderPick = () => { }

} = {}) {
    const dropdownEls = qsa(container, '.book__optionDropdowns .state-dropdown, #reminder-dropdown');
    const instances = [];

    dropdownEls.forEach(dropdown => {

        const toggle = dropdown.querySelector('.dropdown-toggle');
        const menu = dropdown.querySelector('.dropdown-menu');
        const selected = dropdown.querySelector('[data-selected]');
        if (!toggle || !menu || !selected) return;

        const isReminder = dropdown.id === 'reminder-dropdown';

        toggle.addEventListener('click', (e) => {
            e.stopPropagation();
            const isOpen = dropdown.classList.contains('open');
            closeAllDropdowns(instances);
            dropdown.classList.toggle('open', !isOpen);
            menu.style.display = isReminder ? (isOpen ? 'none' : 'grid') : (isOpen ? 'none' : 'block');
        });

        dropdown.querySelectorAll('.dropdown-menu li').forEach(item => {
           // console.log('Adding click listener to dropdown item:', item);
            item.addEventListener('click', (e) => {
                e.stopPropagation();
               // console.log('Dropdown item clicked:', item);
                const value = item.getAttribute('data-value') || '';
                const id = item.getAttribute('data-id') || '';

                dropdown.dataset.value = value;
                dropdown.dataset.id = id;
                selected.textContent = item.textContent.trim();

                dropdown.classList.remove('open', errorClass);
                menu.style.display = 'none';

                if (isReminder) {
                    dropdown.querySelectorAll('.dropdown-menu li').forEach(li => li.classList.remove('active'));
                    item.classList.add('active');
                    selected.classList.add('selected');

                    selected.classList.remove('placeholder');

                    onReminderPick(value, selected.textContent);
                } else {
                    onChange(dropdown);
                }

                dropdown.dispatchEvent(new CustomEvent('summary:recalc', { bubbles: true }));
            });
        });

        instances.push({ el: dropdown, toggle, menu, selected });
    });

    return instances;
}

export function closeAllDropdowns (instances = []) {
    instances.forEach(d => {
        d.el.classList.remove('open');
        if (d.menu) d.menu.style.display = 'none';
    });
   // console.log('All dropdowns closed');
}
